<div class="fn-block-card-modal">
    <div class="fn-block-card-modal__header">
      <div class="fn-block-card-modal__title">
        <div>
            {{ "IP.FINANCES.BLOCK_CARD.MODAL_TITLE" | translate }}
        </div>
      </div>
      <img
        src="../../../../../../assets/new-styles/icons/buttons/close-icon.svg"
        mat-dialog-close
        class="fn-block-card-modal__header__icon"
      />
    </div>
    <div class="fn-block-card-modal__question">
        <span>
            {{ "IP.FINANCES.BLOCK_CARD.MODAL_QUESTION" | translate }}
        </span>
    </div>
    <div *ngIf="this.data && this.data.businessName" class="fn-block-card-modal__supplier">
      <div class="fn-block-card-modal__supplier-field">
        <span class="fn-block-card-modal__supplier-field-key">
          {{ "IP.FINANCES.BLOCK_CARD.MODAL_LABELS.ENTERPRISE" | translate }}
        </span>
        <span class="fn-block-card-modal__supplier-field-value">
          {{ this.data.businessName }}
        </span>
      </div>
      <div class="fn-block-card-modal__supplier-field">
        <span class="fn-block-card-modal__supplier-field-key">
          {{ "IP.FINANCES.BLOCK_CARD.MODAL_LABELS.USERNAME" | translate }}
        </span>
        <span class="fn-block-card-modal__supplier-field-value">
          {{ this.data.userName }}
        </span>
      </div>
      <div class="fn-block-card-modal__supplier-field">
        <span class="fn-block-card-modal__supplier-field-key">
          {{ "IP.FINANCES.BLOCK_CARD.MODAL_LABELS.CARD_NUMBER" | translate }}
        </span>
        <span class="fn-block-card-modal__supplier-field-value">
          <img
            *ngIf="this.data.cardNetwork === 'VISA'"
            src="../../../../assets/new-styles/img/card-visa-blue.png"
            class="fn-block-card-modal__supplier-field-value-image"
          />
          <img
            *ngIf="this.data.cardNetwork === 'MASTER_CARD'"
            src="../../../../assets/new-styles/img/card-master.png"
            class="fn-block-card-modal__supplier-field-value-image"
          />
          {{ this.formatCardNumber(this.data.cardNumber) }}
        </span>
      </div>
    </div>
    <div>
      <div class="fn-block-card-modal__search">
        <label class="fn-block-card-modal__search__placeholder">
            {{ "IP.FINANCES.BLOCK_CARD.MODAL_REASON" | translate }}
        </label>
        <input type="text" class="fn-block-card-modal__search__input" [(ngModel)]="this.blockReason"/>
      </div>
      <div class="fn-block-card-modal__btn">
        <button mat-dialog-close class="fn-block-card-modal__btn-cancel">
            {{ "IP.FINANCES.BLOCK_CARD.MODAL_CANCEL" | translate }}
        </button>
        <button
          class="fn-block-card-modal__btn-confirm"
          (click)="this.blockCard()"  
        >
            {{ "IP.COMMON.CONFIRM-BUTTON" | translate }}
        </button>
      </div>
    </div>
</div>
